import { useEffect } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

export default function PdfViewer({ pdfUrl, onClose }) {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

    useEffect(() => {
      if (!pdfUrl) return;
  
      const handleFullscreenChange = () => {
        console.log("Fullscreen toggled");
        setTimeout(() => {
          window.dispatchEvent(new Event("resize"));
        }, 300);
      };
  
      document.addEventListener("fullscreenchange", handleFullscreenChange);
  
      return () => {
        document.removeEventListener("fullscreenchange", handleFullscreenChange);
      };
    }, [pdfUrl]);
  
    if (!pdfUrl) return null;
  
    return (
      <div
        style={{
          position: "absolute",
          top: '5%',
          height: "90%",
          width: "100%",
          maxWidth: "1200px",
          paddingBottom: "10px",
        }}
      >
        <button onClick={onClose} className="close">close</button>
        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
          <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
        </Worker>
      </div>
    );
  }
  